import { Controller } from 'stimulus';

export default class extends Controller {
    static targets = ["content", "chevron"];
    static values = {
        selectedTags: Array,
        profileUrl: String
    };

    connect() {
        // Filters always start closed
    }

    toggleFilters() {
        if (this.contentTarget.classList.contains('hidden')) {
            this.expand();
        } else {
            this.collapse();
        }
    }

    expand() {
        this.contentTarget.classList.remove('hidden');
        this.chevronTarget.style.transform = 'rotate(180deg)';
    }

    collapse() {
        this.contentTarget.classList.add('hidden');
        this.chevronTarget.style.transform = 'rotate(0deg)';
    }

    toggleTag(event) {
        const tag = event.target.dataset.tag;
        const urlParams = new URLSearchParams(window.location.search);
        let selectedTags = urlParams.get('filtered_tags')
            ? urlParams.get('filtered_tags').split(',').map(t => t.trim())
            : [];

        if (selectedTags.includes(tag)) {
            selectedTags = selectedTags.filter(t => t !== tag);
        } else {
            selectedTags.push(tag);
        }

        if (selectedTags.length > 0) {
            urlParams.set('filtered_tags', selectedTags.join(','));
        } else {
            urlParams.delete('filtered_tags');
        }

        window.location.search = urlParams.toString();
    }
}